import React, { Component } from 'react'
import { reaction } from 'mobx'
import { inject, observer } from 'mobx-react'

import ShopItem from './ShopItem'
import api from '../services'

const YX_SHOP = {
  providerName: "汽车之家严选店",
  deliveryProviderId: 83114480,
  shopLogoUrl: "//mall2.autoimg.cn/malldfs/g2/M0A/BE/E6/autohomecar__ChsEmluSSFuAX3GBAAAQNnx2dq4753.png",
  shopMUrl: "https://store.mall.autohome.com.cn/83114480.html"
}

@inject('cityInfo')
@observer
export default class ShopFloor extends Component {
  constructor(props){
    super(props)
    this.state = {
      list: []
    }

    reaction(
      () => this.props.cityInfo.info.cityId,
      cityId => this.loadData()
    )
    this.loadData = this.loadData.bind(this)
  }

  async loadData(){
    let { cityId } = this.props.cityInfo.info

    let shopRes = await api.getProviderDeliverList(cityId)
    if(shopRes.returncode !== 0) return
    let locationShops = [YX_SHOP,...shopRes.result].filter(ele => ele.shopMUrl)

    for(let i=0,len=locationShops.length;i<len;i++){
      let res = await api.searchItem({
        pageSize: 3,
        // cityId,
        dataSources: '',
        providerId: locationShops[i].deliveryProviderId
      })
      
      if(res.returncode === 0 && res.result && res.result.count >= 3){
        locationShops[i].items = res.result.list
      }
    }

    this.setState({
      list: locationShops.filter(shop => shop.items && shop.items.length === 3)
    })
  }

  componentDidMount(){
    this.loadData()
  }

  render() {
    let len = this.state.list.length
    return(
      <div className={len?'':'fn-hide'}>
        <div className='title'>
          <span>本地好店</span>
        </div>
        {
          this.state.list.map(
            (ele, index) => <ShopItem key={Math.random()}
                                      shop={ele} 
                                      index={index} 
                                      isLast={index === len-1} />
          )
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ShopFloor.js